export default "__VITE_ASSET__BzSmYEQS__"